<template>
  <header class="header" :class='{ blur: menuIsOpen }'>
    <!-- <div class="header__wrapper"> -->
    <router-link to='/' class="header__logo hover">
      <figure>
        <img :src="logo" alt="Production Portugal">
      </figure>
    </router-link>

    <div class="header__menu hover" @click="openMenu">
      <img src="../assets/menu.svg" alt="menu">
    </div>
    <ul class="header__langList">
      <li class="header__langItem hover" :class="{ selected: lang === 'en' }" @click="langClick" data-lang="en">en</li>
      <li class="header__langItem hover" :class="{ selected: lang === 'ja' }" @click="langClick" data-lang="ja">jp</li>
      <li class="header__langItem hover" :class="{ selected: lang === 'ko' }" @click="langClick" data-lang="ko">kr</li>
    </ul>
    <!-- </div> -->
  </header>
</template>

<script>
import anime from 'animejs';
export default {
  name: 'Header',
  mounted() {
    anime({
      targets: ['.header__logo', '.header__menu', '.header__langItem.selected'],
      opacity: 1,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: function (el, i) {
        return 300 * i + 3000;
      }
    });
    anime({
      targets: '.header__langItem',
      opacity: .5,
      duration: 1000,
      easing: 'easeInOutCubic',
      delay: function (el, i) {
        return 300 * i + 3000;
      }
    });
  },
  methods: {
    openMenu() {
      this.$store.commit('toggleMenu', true);
    },
    langClick(event) {
      const newLang = event.target.dataset.lang;
      this.$store.dispatch('changeLang', { newLang, route: this.$route.name });
    }
  },
  computed: {
    menuIsOpen() {
      return this.$store.state.showMenu;
    },
    logo() {
      return this.$store.state.config.logo;
    },
    lang() {
      return this.$store.state.lang;
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";

.header {
  position: absolute;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px 100px;
  margin: 0 auto;

  &__wrapper {
    width: 100%;
    max-width: 1240px;
  }

  &__logo {
    opacity: 0;

    figure {
      width: 120px;

      img {
        width: 100%;
      }
    }
  }

  &__menu {
    opacity: 0;
    padding: 12px 7px;
    border-radius: 50%;
    background-color: var(--M01);
    transform: scale(1);
    transition: transform .2s cubic-bezier(.41, .15, .41, 1.31);

    &:hover {
      transform: scale(1.1);
    }
  }

  &__langList {}

  &__langItem {
    display: inline-block;
    color: var(--Neu01);
    font-family: 'CamptonBold';
    font-size: 14px;
    transition: opacity .2s ease-in;
    opacity: 0;
    text-transform: uppercase;

    &:hover,
    &.selected {
      opacity: 1 !important;
    }
  }

  @include mq(0, 768px) {
    padding: 20px;

    &__logo {
      figure {
        width: 80px;
      }
    }

    &__langItem {
      padding: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue